export default __webpack_public_path__ + "static/media/indexx_logo_white.13a6ac23.svg";